type ProgressBarProps = {
  currentStep: number;
  totalSteps: number;
  className?: string;
};

const ProgressBar = ({
  currentStep,
  totalSteps,
  className = "",
}: ProgressBarProps) => {
  const percentage = Math.min(
    Math.max((currentStep / totalSteps) * 100, 0),
    100,
  );

  return (
    <div
      className={[
        "w-full h-3 rounded-[50px] bg-gray-200 overflow-hidden",
        className,
      ].join(" ")}
    >
      <div
        className="h-full bg-[#248AFF] transition-all duration-300"
        style={{ width: `${percentage}%` }}
      />
    </div>
  );
};

export default ProgressBar;
